import styled, { Color, Spacing, Breakpoint, BorderRadius, Font, css, Utils } from '@nfinite/react-hubstairs/styled'
import IconComponent from 'components/Commons/Icon'

import TemplateComponent from 'components/Commons/Inputs/Template'

export const Container = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${({ reverse }) =>
    reverse
      ? css`
          flex-direction: row-reverse;
          justify-content: space-between;
        `
      : css`
          justify-content: flex-start;
        `}
  ${({ scalable }) =>
    scalable &&
    css`
      ${Utils.generateScaleRollhover({ fit: false })}
    `}
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: default;
    `}
  ${Spacing.generateMargin({ vertical: 'xxs' })}
`

export const Wrapper = styled('div')`
  display: inline-block;
  vertical-align: middle;
  background-color: transparent;
`

const ICON_SIZES = {
  xs: 15,
  sm: 20,
  regular: 25,
}

const _Icon = ({ color, ...ownProps }) => <IconComponent {...ownProps} />
export const IconCheckbox = styled(_Icon)`
  ${({ iconSize = 'regular' }) => css`
    width: ${ICON_SIZES[iconSize]}px;
    height: ${ICON_SIZES[iconSize]}px;
  `}
`

export const IconRadio = styled('div')`
  width: 20px;
  height: 20px;
  background-color: ${Color.get('background', 'main')};
  border: ${({ theme, checked }) =>
    checked ? `4px solid ${theme.getColor('primary')}` : `1px solid ${theme.getColor('text', 'gray')}`};
  ${BorderRadius.generate({ all: 'round' })}
`

export const IconRadioWithCheck = styled('div')`
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ checked }) => (checked ? Color.get('primary') : 'transparent')};
  border: ${({ theme, checked }) =>
    checked ? `1px solid ${theme.getColor('primary')}` : `1px solid ${theme.getColor('gray', 'main')}`};
  ${BorderRadius.generate({ all: 'xxl' })}
  position: relative;
  cursor: pointer;
`

export const Element = styled('span')`
  display: block;
  ${Font.generate({ size: 'm' })}
  color: ${Color.get('text')};
  width: 100%;
  ${({ reverse }) =>
    reverse
      ? css`
          ${Spacing.generateMargin({ right: 'm' })}
        `
      : css`
          ${Spacing.generateMargin({ left: 'xs' })}
        `}
`

export const Template = styled(TemplateComponent)`
  ${Spacing.generatePadding({ all: 'xs' })}

  ${Breakpoint.greaterThanMobile()} {
    ${Spacing.generatePadding({ horizontal: '0' })}
  }
`

export const RadioChecked = styled(IconComponent)`
  width: 12px;
  height: 12px;
`
